module.exports = __webpack_public_path__ + "img/main_electric_line.e43873c8.png";